import {HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {Injectable} from "@angular/core";

export type HandlerError = <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {

  constructor() { }

  createHandleError = <T>(serviceName = '') =>
    (operation = 'operation') => this.handleError<T>(serviceName, operation)

  handleError<T>(serviceName = '', operation = 'operation') {
    return (error: HttpErrorResponse): Observable<T> => {
      const message = (error.error instanceof ErrorEvent) ?
        error.error.message :
        `server returned code ${error.status} with body "${error.error}"`;

      if (error.status === 400) {
        return throwError(error.error as T);
      } else {
        return throwError(error);
      }

      // TODO: Tratar Erro 500
    };
  }
}
